import condition from 'dynamic-condition';
import React from 'react';
/*****************************************************
 * Locals
 ******************************************************/
import { EditorContext } from '../../../ElementRenderContext';
import getPathValue from '../../../util/getPathValue';
import RenderModule from './RenderModule';
import settingComponents from '../index';
import Label from '../Label/Label';

/**
 * Resolves path to values
 * @param {array} arr an Array of conditions JSON format
 * @param {object} resource
 * @returns {array} array of pure conditions
 */
const resolveValues = (conditions, resource) =>
    conditions.map((c) =>
        Array.isArray(c)
            ? resolveValues(c, resource)
            : /\//.test(c)
            ? getPathValue(c, resource)
            : c
    );

const RenderTemplate = React.memo(function _RenderTemplate(props) {
    const { activeHover, handleChange, module, parentModule } = props;
    const { display, currentEditItem } = React.useContext(EditorContext);

    // console.log(
    //     module.path,
    //     module.conditions && resolveValues(module.conditions, currentEditItem)
    // );
    if (
        module.conditions &&
        !condition(resolveValues(module.conditions, currentEditItem)).matches
    ) {
        return null;
    }

    if (
        activeHover &&
        module.hasOwnProperty('hoverable') &&
        !module.hoverable
    ) {
        return null;
    }

    // Render provided template
    if (module.template) {
        const Component = settingComponents[module.template] || 'div';

        return (
            <div style={{ marginTop: 20 }}>
                {module.label && (
                    <Label
                        display={display}
                        module={module}
                        activeHover={activeHover}
                    >
                        {module.label}
                    </Label>
                )}
                <Component
                    {...props}
                    display={display}
                    currentEditItem={currentEditItem}
                />
            </div>
        );
    }

    if (module.modules) {
        return (
            <>
                {props.index !== undefined && module.label && (
                    <Label
                        display={display}
                        module={module}
                        activeHover={activeHover}
                    >
                        {module.label}
                    </Label>
                )}

                {module.modules.map((childMod, modIndex) => (
                    <RenderTemplate
                        key={modIndex}
                        index={modIndex}
                        module={childMod}
                        parentModule={module}
                        activeHover={activeHover}
                        handleChange={handleChange}
                    />
                ))}
            </>
        );
    } else {
        return (
            <RenderModule
                {...props}
                display={display}
                parentModule={parentModule}
            />
        );
    }
});

export default RenderTemplate;
